import { axiosWalletRequest, METHOD } from '../api/Requests';

export const getById = (id, year) => axiosWalletRequest(`Aliquota?id=${id}&year=${year}`, METHOD.GET);

export const update = (id, aliquotasJson) => {
  return axiosWalletRequest(`Aliquota/${id}`, METHOD.PUT, aliquotasJson);
}

